import React, { useState } from 'react';
import { Screen } from '../types';

const PaymentScreen = ({ 
  userData, validity, startDate, endDate, memberCount, navigateTo 
}) => {
  const [selected, setSelected] = useState('UPI');
  const [isPaying, setIsPaying] = useState(false);

  const priceMap = {
    '10 Days': 150,
    '1 Month': 350,
    '6 Months': 1600
  };
  const amount = (priceMap[validity] || 150) * memberCount;

  const handlePay = () => {
    setIsPaying(true);
    setTimeout(() => {
      setIsPaying(false);
      navigateTo(Screen.PaymentSuccess);
    }, 2000);
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  return (
    <div className="ilp-screen gray-bg">
      <div className="ilp-header white-bg">
        <button className="ilp-back-btn" onClick={() => navigateTo(Screen.PermitValidity)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2">
            <path d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h2>Payment Options</h2>
        <div className="ilp-header-spacer"></div>
      </div>

      <div className="ilp-payment-content">
        <div className="ilp-payment-summary">
          <div className="ilp-payment-amount">
            <label>Total Payable</label>
            <h1>₹{amount.toFixed(2)}</h1>
          </div>
          
          <div className="ilp-payment-details">
            <div className="ilp-payment-row">
              <div>
                <label>Applicant</label>
                <p>{userData.name || 'User'}</p>
              </div>
              <div>
                <label>Group Size</label>
                <p>{memberCount} {memberCount === 1 ? 'Person' : 'People'}</p>
              </div>
            </div>
            
            <div className="ilp-payment-dates">
              <div>
                <label>Valid From</label>
                <p>{formatDate(startDate)}</p>
              </div>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="2">
                <path d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
              <div className="text-right">
                <label>Valid Until</label>
                <p>{formatDate(endDate)}</p>
              </div>
            </div>

            <div className="ilp-payment-row">
              <div>
                <label>Permit Type</label>
                <span className="ilp-permit-badge">{validity} Tourist</span>
              </div>
              <div>
                <label>Ref ID</label>
                <p className="ilp-ref-id">AR-ILP-2024-9876</p>
              </div>
            </div>
          </div>
        </div>

        <div className="ilp-payment-methods">
          <h3>Recommended</h3>
          <button 
            className={`ilp-payment-option ${selected === 'UPI' ? 'selected' : ''}`}
            onClick={() => setSelected('UPI')}
          >
            <div className="ilp-payment-option-left">
              <div className="ilp-payment-icon blue">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
                </svg>
              </div>
              <div className="ilp-payment-text">
                <h4>UPI</h4>
                <p>Google Pay, PhonePe, Paytm</p>
              </div>
            </div>
            <div className={`ilp-check-circle ${selected === 'UPI' ? 'checked' : ''}`}>
              {selected === 'UPI' && (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                  <path d="M5 13l4 4L19 7" />
                </svg>
              )}
            </div>
          </button>
        </div>

        <div className="ilp-payment-methods">
          <h3>Cards & Netbanking</h3>
          <div className="ilp-payment-cards">
            <button 
              className={`ilp-payment-option ${selected === 'CARD' ? 'selected' : ''}`}
              onClick={() => setSelected('CARD')}
            >
              <div className="ilp-payment-option-left">
                <div className="ilp-payment-icon gray">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                  </svg>
                </div>
                <div className="ilp-payment-text">
                  <h4>Credit / Debit Card</h4>
                  <p>Visa, Mastercard, RuPay</p>
                </div>
              </div>
              <div className={`ilp-check-circle ${selected === 'CARD' ? 'checked' : ''}`}>
                {selected === 'CARD' && (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                    <path d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>
            </button>

            <button 
              className={`ilp-payment-option ${selected === 'NB' ? 'selected' : ''}`}
              onClick={() => setSelected('NB')}
            >
              <div className="ilp-payment-option-left">
                <div className="ilp-payment-icon gray">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <div className="ilp-payment-text">
                  <h4>Netbanking</h4>
                  <p>All Indian banks supported</p>
                </div>
              </div>
              <div className={`ilp-check-circle ${selected === 'NB' ? 'checked' : ''}`}>
                {selected === 'NB' && (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                    <path d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>
            </button>
          </div>
        </div>
      </div>

      <div className="ilp-payment-footer">
        <button 
          className={`ilp-primary-btn full ${isPaying ? 'loading' : ''}`}
          onClick={handlePay}
          disabled={isPaying}
        >
          {isPaying ? (
            <div className="ilp-spinner"></div>
          ) : (
            <>
              <span>Pay ₹{amount.toFixed(2)}</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </>
          )}
        </button>
        <p className="ilp-payment-note">Payments are secured by the Govt. of Arunachal Pradesh.</p>
      </div>
    </div>
  );
};

export default PaymentScreen;

